import { defineStore } from 'pinia';
import SecurityState from './state';
import { IStoreSecurityState } from './security.interface';
import {
  _getCsrf,
  _setCsrf,
  _getFingerprint,
  _getFormNameListToGet,
  _addCsrfFromList
} from './actions';
import { FormNameEnum } from '@shared/enum/form-name.enum';
import { ICsrf } from '@shared/interface/security.interface';

export const useSecurityStore = defineStore('security', {
  state: (): IStoreSecurityState => ({ ...SecurityState }),
  actions: {
    async getCsrf(formName: FormNameEnum): Promise<ICsrf | undefined> {
      return _getCsrf(this, formName);
    },
    setCsrf(csrf: ICsrf) {
      return _setCsrf(this, csrf);
    },
    getFingerprint(): Promise<string> {
      return _getFingerprint(this);
    },
    getFormNameListToGet(): Array<string> {
      return _getFormNameListToGet(this);
    },
    addCsrfFromList(tokenList: Array<ICsrf>) {
      return _addCsrfFromList(this, tokenList);
    },
  },
});
